import Button from '@mui/material/Button'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { OrderProduct } from '../../entities/order-product/OrderProduct'
import Modal from '../modal/Modal'
import ProductControlSwitcher from '../product-control-switcher/ProductControlSwitcher'
import ProductDeclineButton from '../product-decline-button/ProductDeclineButton'
import ProductItem from '../product-item/ProductItem'
import messages from './ProductIncomingModal.messages'

export interface IOwnProps {
  product: OrderProduct
  open: boolean
  onClose: () => void
}

export interface IStateProps { }

export interface IDispatchProps {
  requestProductAccept: (product: OrderProduct) => void
}

export type IProps = IOwnProps & IStateProps & IDispatchProps

const ProductIncomingModal: React.FC<IProps> = (props) => {
  const {
    product,
    open,
    onClose,
    requestProductAccept,
  } = props

  const handleAcceptClick = () => {
    requestProductAccept(product)
    onClose()
  }

  return (
    <Modal
      modalName='product-incoming'
      open={open}
      onClose={onClose}
      header={() => (
        <ProductItem
          product={product}
          shouldShowControls={false}
          shouldOpenModal={false}
          isModal={true}
        />
      )}
    >
      <ProductControlSwitcher
        initialContent={() => (
          <Button
            onClick={handleAcceptClick}
            variant='contained'
            color='primary'
            fullWidth
          >
            <FormattedMessage {...messages.accept} />
          </Button>
        )}
        toggleContent={() => (
          <ProductDeclineButton product={product} onModalClose={onClose} />
        )}
      />
    </Modal>
  )
}

export default ProductIncomingModal
